module.exports = __webpack_public_path__ + "static/img/7.5139fd7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/sp/7.png
// module id = 06tf
// module chunks = 0